<template>
  <ProductFilter
    :isOnProductDetailPage="isOnProductDetailPage"
    :placeholderText="placeholderText"
    :totalFiltersActive="totalFiltersActive"
    filterType="tag"
    title="Tags"
    tooltipText="For example, new or featured"
  />
</template>

<script>
  import ProductFilter from '@/components/ProductFilter'

  export default {
    name: 'ProductFilterTags',
    components: {
      ProductFilter
    },
    props: {
      isOnProductDetailPage: Boolean,
      totalFiltersActive: Number
    },
    computed: {
      placeholderText: function () {
        return 'Start typing "New"'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ProductFilterTags.vue